// @flow

import _ from 'lodash';

import ReduceStore from 'PMT/flux/ReduceStore';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import RestaurantDashboardInfo from 'PMT/entities/dashboard/RestaurantDashboardInfo';

class DashboardStore extends ReduceStore {

  getInitialState() {
    return {
      apiError: null, // ApiError
      restaurantDashboardInfo: null, // RestaurantDashboardInfo
    }
  }

  getStateObjectsMap() {
    return {
      payoutList: new ApiError(),
      restaurantDashboardInfo: new RestaurantDashboardInfo(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getRestaurantDashboardInfo(): RestaurantDashboardInfo {
    return this._state.restaurantDashboardInfo;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      //
      // Get for date
      //

      case ActionTypes.GET_RESTAURANT_DASHBOARD_RESPONSE_SUCCESS:
        nextState.restaurantDashboardInfo = action.restaurantDashboardInfo;
        nextState.apiError = null;

        return nextState;

      case ActionTypes.GET_RESTAURANT_DASHBOARD_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;


      default:
        return nextState;
    }
  }

}

export default new DashboardStore();
